import { useQuery, useSubscription } from "@apollo/react-hooks";
import { My_TIME_MY_TIME_GET_OPEN_REQUEST_LIST_WITHOUT_EXAMINER } from "my-time/graphql/queries";
import { MY_TIME_REQUESTS_SUBSCRIPTION } from "my-time/graphql/subscriptions";

export const useMyTimeRequestsWithoutExaminer = ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}) => {
  const { data, loading, error, refetch } = useQuery(
    My_TIME_MY_TIME_GET_OPEN_REQUEST_LIST_WITHOUT_EXAMINER,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        startDate,
        endDate,
      },
    },
  );

  useSubscription(MY_TIME_REQUESTS_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    onData: () => {
      refetch();
    },
  });

  return {
    data: data?.getOpenRequestsListWithoutExaminer || [],
    loading,
    error,
    refetch,
  };
};

export default useMyTimeRequestsWithoutExaminer;
